module.exports = __webpack_public_path__ + "img/logo.e80384ef.png";